import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getBackendAPIClient } from "../lib/backendAPIClient";
import { deleteTransactionContract } from "../common/contracts/delete-transaction.contract";

const deleteTransactionContractClient = getBackendAPIClient(
    deleteTransactionContract,
);

export function useSoftDeleteTransaction() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (transactionId: number) =>
            deleteTransactionContractClient.softDeleteTransaction({
                params: {
                    transactionId,
                },
            }),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ["transactions"],
            });
        },
    });
}

export function useRestoreTransaction() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (transactionId: number) =>
            deleteTransactionContractClient.restoreTransaction({
                params: {
                    transactionId,
                },
            }),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ["transactions"],
            });
        },
    });
}

export function useHardDeleteTransaction() {
    return useMutation({
        mutationFn: (transactionId: number) =>
            deleteTransactionContractClient.hardDeleteTransaction({
                params: {
                    transactionId,
                },
            }),
    });
}
